export default "__VITE_ASSET__DgYwvG0R__"